import React from "react";

import { Image } from 'react-native'
import logo from './logo.jpeg'
import { styles } from './styles'

export const LogoHP: React.FC = () => (
  <Image resizeMode="contain" style={styles.image} source={{uri:logo}} />
);
